// extracted by mini-css-extract-plugin
export var indeterminate = "_5e-5";
export var md = "_5e-4";
export var semantic = "_5e-6";
export var sm = "_5e-3";
export var text = "_5e-7";
export var toggleInput = "_5e-0";
export var toggleSwitch = "_5e-1";
export var xs = "_5e-2";